import { render, staticRenderFns } from "./AddInstruction.vue?vue&type=template&id=33d49d54&scoped=true&"
import script from "./AddInstruction.vue?vue&type=script&lang=ts&"
export * from "./AddInstruction.vue?vue&type=script&lang=ts&"
import style0 from "./AddInstruction.vue?vue&type=style&index=0&id=33d49d54&scoped=true&lang=css&"
import style1 from "./AddInstruction.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d49d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
